// extracted by mini-css-extract-plugin
export default {"FolderNavigationContainer":"FolderNavigation_FolderNavigationContainer__9c4x4","FolderNavigationCTAIcon":"FolderNavigation_FolderNavigationCTAIcon__2uw+5"};